import { c as _c } from "react/compiler-runtime";
import { Box, Typography } from '@mui/material';
import { type CtaAnalyticsProps, CtaLink } from '../../CTA/CtaLink';
import { StarRatingTooltip } from '../StarRatingTooltip';
import { StarRating } from './StarRating';
export type RatingRoundupsProps = {
  reviewLink?: string | null;
  starRating?: number;
  excludeLabel?: boolean;
  inline?: boolean;
  asColumn?: boolean;
  centered?: boolean;
  segmentActionSection?: string;
  isMonetizing?: boolean;
  name: string;
};
export function RatingRoundups(t0) {
  const $ = _c(16);
  const {
    reviewLink,
    starRating,
    excludeLabel: t1,
    centered: t2,
    segmentActionSection,
    isMonetizing: t3
  } = t0;
  const excludeLabel = t1 === undefined ? false : t1;
  const centered = t2 === undefined ? false : t2;
  const isMonetizing = t3 === undefined ? true : t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      isTrackOnly: true
    };
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  const starRatingAnalytics = t4;
  const t5 = Number(starRating);
  let t6;
  if ($[1] !== t5) {
    t6 = t5.toFixed(1);
    $[1] = t5;
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  const formattedRating = t6;
  const t7 = centered ? "center" : "unset";
  let t8;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      display: "flex",
      flexDirection: "column"
    };
    $[3] = t8;
  } else {
    t8 = $[3];
  }
  let t9;
  if ($[4] !== excludeLabel || $[5] !== isMonetizing || $[6] !== segmentActionSection) {
    t9 = !excludeLabel && <Box display="flex" flexDirection="row"><Typography variant="bodySmall" sx={{
        paddingRight: 1
      }}>NerdWallet rating</Typography><Box><StarRatingTooltip maxWidth="17.25rem" segmentActionSection={segmentActionSection} isMonetizing={isMonetizing} /></Box></Box>;
    $[4] = excludeLabel;
    $[5] = isMonetizing;
    $[6] = segmentActionSection;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  let t10;
  if ($[8] !== formattedRating || $[9] !== reviewLink || $[10] !== starRating) {
    t10 = reviewLink ? <CtaLink href={reviewLink} target="_blank" aria-label={`${formattedRating}/5 - rated ${formattedRating} out of 5`} analytics={starRatingAnalytics} parameterActions={[]} skipShoppingFinishedEvent={true} isReview={true} sx={{
      display: "block",
      touchAction: "manipulation",
      textDecoration: "none",
      "&:hover": {
        textDecoration: "none"
      },
      "&:hover span:first-of-type": {
        textDecoration: "underline"
      },
      "&:focus": {
        borderRadius: "4px"
      }
    }}><StarRating formattedRating={formattedRating} reviewLink={reviewLink} starRating={starRating} /></CtaLink> : <StarRating formattedRating={formattedRating} reviewLink={reviewLink} starRating={starRating} />;
    $[8] = formattedRating;
    $[9] = reviewLink;
    $[10] = starRating;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== t10 || $[13] !== t7 || $[14] !== t9) {
    t11 = <Box alignItems={t7} sx={t8}>{t9}{t10}</Box>;
    $[12] = t10;
    $[13] = t7;
    $[14] = t9;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  return t11;
}